




















import Vue from 'vue'
import { ExpedienteDto } from '@/Application/Expediente/ExpedienteDto'
export default Vue.extend({
  name: 'WonProcedureRow',
  components: { },
  props: {
    expediente: {
      type: ExpedienteDto,
      required: true
    }
  }
})
